import { z } from 'zod';
import moment from 'moment';

export const toDateString = (value: unknown): unknown => {
  if (value === null || value === undefined || value === '') return null;
  if (moment.isMoment(value)) return value.isValid() ? value.toISOString() : null;
  if (value instanceof Date) return moment(value).toISOString();
  return value;
};

export const dateStringSchema = z.preprocess(toDateString, z.string().nullable());

export const EventNoteSchema = z.object({
  id: z.string(),
  content: z.string(),
  createdById: z.string(),
  eventActivityId: z.string(),
  createdDateTime: z.string(),
});
